import { lazy } from "react";

import { Navigate, RouteObject } from "react-router-dom";

enum RouteType {
  Public = "Public",
  Private = "Private",
}

export type Routes = {
  [routeName in RouteType]: RouteObject[];
};

const ErrorLayoutPage = lazy(() => import("layouts/ErrorPageLayout"));
const PublicLayoutPage = lazy(() => import("layouts/PublicPageLayout"));
const PrivateLayoutPage = lazy(() => import("layouts/PrivatePageLayout"));

const LoginHomePage = lazy(() => import("pages/home"));

const ChipPage = lazy(() => import("pages/admin/pages/Chips/Chip"));
const ChipsListPage = lazy(() => import("pages/admin/pages/Chips/ChipsList"));
const DashboardPage = lazy(() => import("pages/admin/pages/Dashboard"));
const DocumentListingPage = lazy(
  () => import("pages/admin/pages/Documents/DocumentListing")
);
const MemberPage = lazy(() => import("pages/admin/pages/Members/Member"));
const MemberListingPage = lazy(
  () => import("pages/admin/pages/Members/MemberListing")
);
const NotificationPage = lazy(
  () => import("pages/admin/pages/Notifications/Notification")
);
const NotificationListingPage = lazy(
  () => import("pages/admin/pages/Notifications/NotificationListing")
);
const CommissionPage = lazy(
  () => import("pages/admin/pages/Commissions/Commission")
);
const CommissionFolderPage = lazy(
  () => import("pages/admin/pages/Commissions/components/CommissionFolder")
);
const CommissionSubFolderPage = lazy(
  () => import("pages/admin/pages/Commissions/components/CommissionSubFolder")
);
const CommissionsListingPage = lazy(
  () => import("pages/admin/pages/Commissions/CommissionsListing")
);
const CompaniePage = lazy(() => import("pages/admin/pages/Companies/Companie"));
const CompanieListingPage = lazy(
  () => import("pages/admin/pages/Companies/CompanieListing")
);
const FormWorkFunctionPage = lazy(
  () => import("pages/admin/pages/WorkFunctions/FormWorkFunction")
);
const CalendarPage = lazy(
  () => import("pages/admin/pages/Commissions/components/CalendarPage")
);
const MemberAccessEnablePage = lazy(
  () => import("pages/admin/pages/Members/MemberAccessEnable")
);
const WorkFunctionsListPage = lazy(
  () => import("pages/admin/pages/WorkFunctions/WorkFunctionsList")
);
const SearchChipsPage = lazy(
  () => import("pages/admin/pages/SearchChips/SearchChips")
);

const routes: Routes = {
  Private: [
    {
      path: "admin/*",
      element: <PrivateLayoutPage />,
      errorElement: <ErrorLayoutPage />,
      children: [
        {
          path: "home",
          element: <DashboardPage />,
        },
        {
          path: "comissoes",
          element: <CommissionsListingPage />,
        },
        {
          path: "comissoes/adicionar",
          element: <CommissionPage />,
        },
        {
          path: "comissoes/:idCommission/calendar",
          element: <CalendarPage />,
        },
        {
          path: "comissoes/:id/pastas",
          element: <CommissionFolderPage />,
        },
        {
          path: "comissoes/:id/pastas/:idPasta",
          element: <CommissionSubFolderPage />,
        },
        {
          path: "pesquisaFichas",
          element: <SearchChipsPage />,
        },
        {
          path: "fichas",
          element: <ChipsListPage />,
        },
        {
          path: "ficha/adicionar/:idCommission/:idPasta",
          element: <ChipPage />,
        },
        {
          path: "ficha/:id/editar",
          element: <ChipPage />,
        },
        {
          path: "ficha/:id/detalhar",
          element: <ChipPage />,
        },
        {
          path: "membros",
          element: <MemberListingPage />,
        },
        {
          path: "membros/adicionar",
          element: <MemberPage />,
        },
        {
          path: "membros/:id/editar",
          element: <MemberPage />,
        },
        {
          path: "membros/habilitar-acesso",
          element: <MemberAccessEnablePage />,
        },
        {
          path: "documentos",
          element: <DocumentListingPage />,
        },
        {
          path: "funcoes",
          element: <WorkFunctionsListPage />,
        },
        {
          path: "funcoes/:id/editar",
          element: <FormWorkFunctionPage />,
        },
        {
          path: "funcoes/adicionar",
          element: <FormWorkFunctionPage />,
        },
        {
          path: "empresas",
          element: <CompanieListingPage />,
        },
        {
          path: "empresas/adicionar",
          element: <CompaniePage />,
        },
        {
          path: "empresas/:id/editar",
          element: <CompaniePage />,
        },
        {
          path: "emailsAvisos",
          element: <NotificationListingPage />,
        },
        {
          path: "emailsAvisos/adicionar",
          element: <NotificationPage />,
        },
        {
          path: "*",
          element: <Navigate to="/admin/home" />,
        },
      ],
    },
  ],

  Public: [
    {
      path: "/",
      element: <PublicLayoutPage />,
      errorElement: <ErrorLayoutPage />,
      children: [
        {
          path: "/",
          element: <LoginHomePage />,
        },
      ],
    },
  ],
};

export const AppRoutes = Object.keys(routes).flatMap((routeName) => {
  return routes[routeName as RouteType];
});
